import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AventiorLogo2 from "../../assets/CPV-Auto-logo-Final.png";
import "./header.scss";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as acts from "../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalEsign from "../Modal/Signature/ModalSign";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ProgressBar from "../../components/ProgressBar";
import { action } from "../../constants/action";
import {
  Divider,
  SwipeableDrawer,
  Chip,
  Tooltip,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import SettingDrawer from "../SettingsDrawer/SettingsDrawer";
import auth from "../../config/auth";
import UploadedFilesList from "../UploadedFilesList";
import { format } from "date-fns";
import {
  adminRoutes,
  preProRoutes,
  proRoutes,
  sharedRoutes,
  valiRoutes,
} from "../../routes/routeConstants";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MuiAlert from "@mui/material/Alert";
import Label from "../Label/Label";

const getAlertConfig = (status) => {
  switch (status) {
    case "Running":
      return {
        severity: "success",
        message: (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Label text="VLM is currently" />
              <Label
                text="RUNNING"
                fontWeight="500"
                color="green"
                paddingLeft="5px"
              ></Label>
            </div>
          </>
        ),
        icon: <CheckCircleIcon fontSize="inherit" />,
        color: "green",
      };
    case "Stopped":
      return {
        severity: "error",
        message: (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Label text="VLM is currently" />
              <Label
                text="STOPPED"
                fontWeight="500"
                color="#d32f2f"
                paddingLeft="5px"
              ></Label>
            </div>
          </>
        ),
        icon: <CancelIcon fontSize="inherit" />,
        color: "#d32f2f",
      };
    default:
      return {
        severity: "warning",
        message: (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Label text="VLM is currently" />
            <Label
              text="UNKNOWN"
              fontWeight="500"
              color="gray"
              paddingLeft="5px"
            ></Label>
          </div>
        ),
        icon: <HelpOutlineIcon fontSize="inherit" />,
        color: "gray",
      };
  }
};

export default function Header() {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSignPad, setopenSignPad] = useState(false);
  const open = Boolean(anchorEl);
  const [openSettingDrawer, setOpenSettingDrawer] = useState(false);
  const navigate = useNavigate();
  const userLogout = useSelector((state) => state?.auth?.userLogout);
  const vlmStatusFromAPi = useSelector((state) => state?.auth?.vlmStatus);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [openUploadedFilePreviewDialog, setOpenUploadedFilePreviewDialog] =
    useState(false);

  const [vlmStatus, setVlmStatus] = useState(null); // 'Running', 'Stopped', 'error'
  const [vlmLoading, setVlmLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const { severity, message, icon } = getAlertConfig(vlmStatus);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (userLogout?.apiSuccess) {
      localStorage.clear();
      navigate("/");
      auth.logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogout]);

  useEffect(() => {
    if (
      vlmStatusFromAPi?.message !== null &&
      vlmStatusFromAPi?.message !== undefined
    ) {
      setVlmLoading(false);
      setVlmStatus(vlmStatusFromAPi?.message);
      setOpenAlert(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vlmStatusFromAPi]);

  const handleLogout = () => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/");
    } else {
      const showNotification = true;
      dispatch(acts.userLogout(showNotification));
    }
    setAnchorEl(null);
  };

  const handlePreviewFIles = () => {
    setAnchorEl(null);
    // window.open("/files-viewer", "_blank"); //to open new page
    window.open(`/${sharedRoutes.filesViewer}`, "_blank"); //to open new page
  };

  const handleEsignDialogBoxOpen = () => {
    setLoader(false);
    setopenSignPad(true);

    setAnchorEl(null);
  };
  const handleEsignDialogBoxClose = () => {
    setopenSignPad(false);
    setAnchorEl(null);
  };
  const handleHome = () => {
    if (localStorage.getItem("userRole") === "pre-processor") {
      // navigate("/pre-processor-dashboard");
      navigate(`/${preProRoutes.preProDashboard}`);
    }
    if (localStorage.getItem("userRole") === "processor") {
      // navigate("/processor-dashboard");
      navigate(`/${proRoutes.proDashboard}`);
    }
    if (localStorage.getItem("userRole") === "validator") {
      // navigate("/validator-dashboard");
      navigate(`/${valiRoutes.valiDashboard}`);
    }
    // if (localStorage.getItem("userRole") === "investigator") {
    //   navigate("/logs");
    //   // history.push("logs");
    // }
    if (localStorage.getItem("userRole") === "administrator") {
      // navigate("/validator-dashboard");
      navigate(`/${adminRoutes.batchMonitor}`);
    }
  };

  const toggleDrawer = (value) => {
    setOpenSettingDrawer(value);
    setAnchorEl(null);
  };

  const handlePreviewUploadedFilesClick = () => {
    setAnchorEl(null);
    handlePreviewUploadedFiles();
  };

  const handlePreviewUploadedFiles = () => {
    setOpenUploadedFilePreviewDialog(true);
  };

  const checkVlmStatus = async () => {
    setVlmLoading(true);
    dispatch(acts.checkVlmStatus());
  };

  const handleAlertClose = (event, reason) => {
    dispatch(acts.setClearVlmStatus());
    setOpenAlert(false);
    // if (reason === "clickaway") return;
    setVlmStatus(null);
  };

  return (
    <>
      <Box className="header">
        <AppBar position="static">
          <Toolbar className="toolBar">
            <img
              src={AventiorLogo2}
              className="logo"
              onClick={() => handleHome()}
              alt="AventiorLogo"
            />
            <div className="vertical"></div>
            {/* <div className="CPV_Logo">
              <img src={CPVLogo} alt="logo" />
            </div> */}
            <Typography variant="subtitle1" className="HeaderProjectName">
              {action?.LOGO}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1, pr: 2 }}>
              <Tooltip
                title={
                  vlmLoading
                    ? "Checking VLM status..."
                    : vlmStatus === "Running"
                    ? "VLM is Running"
                    : vlmStatus === "Stopped"
                    ? "VLM is stopped"
                    : "Click to check VLM status"
                }
              >
                <Chip
                  clickable
                  variant="filled"
                  size="small"
                  onClick={checkVlmStatus}
                  icon={
                    vlmLoading ? (
                      <CircularProgress size={14} />
                    ) : vlmStatus === "Running" ? (
                      <CheckCircleIcon color="success" />
                    ) : vlmStatus === "Stopped" ? (
                      <CancelIcon color="error" />
                    ) : (
                      <HelpOutlineIcon color="gray" />
                    )
                  }
                  label="VLM"
                  sx={{
                    fontSize: "12px",
                    height: 28,
                    borderRadius: "20px",
                    minWidth: "70px",
                    borderColor:
                      vlmStatus === "Running"
                        ? "green"
                        : vlmStatus === "Stopped"
                        ? "#d32f2f"
                        : "gray",
                    color:
                      vlmStatus === "Running"
                        ? "green"
                        : vlmStatus === "Stopped"
                        ? "#d32f2f"
                        : "gray",
                  }}
                />
              </Tooltip>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingRight: "15px",
                  alignItems: "flex-end", // aligns content to the right
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ margin: "0px !important", padding: "0px !important" }}
                >
                  {localStorage?.userName || "Oscar Thomsen"}
                  {/* (
              {localStorage?.userName
                ? localStorage?.userRole?.charAt(0).toUpperCase() +
                  localStorage?.userRole?.slice(1)
                : "Admin"}
              ) */}
                </Typography>

                <Typography variant="caption" color="text.secondary">
                  Last login:{" "}
                  {isNaN(new Date(localStorage.last_login))
                    ? localStorage.last_login ?? "N/A"
                    : format(new Date(localStorage.last_login), "PPpp")}
                </Typography>
              </Box>
            </Box>

            <IconButton
              size="medium"
              edge="start"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                className="user-profile-icon"
              />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              className="user-profile"
              onClose={(e) => handleCloseMenu(e)}
              MenuListProps={{
                "aria-labelledby": "demo-positioned-button",
              }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div className="menu-wrapper">
                <div className="menu-version-wrap">
                  <h3 className="menu-title">About</h3>
                  <div className="menu-details">
                    <p className="app-name">CPV-Auto NXG v2.0</p>
                    <p className="release-date">Released: May 2025</p>
                  </div>
                </div>

                <Divider className="menu-divider" />
                {localStorage.getItem("userRole") === "pre-processor" ||
                localStorage.getItem("userRole") === "processor" ||
                localStorage.getItem("userRole") === "validator" ? (
                  <MenuItem onClick={handleEsignDialogBoxOpen}>
                    {action.E_SIGN}
                  </MenuItem>
                ) : (
                  ""
                )}
                <MenuItem onClick={() => toggleDrawer(true)} disabled>
                  {action.SETTINGS}
                </MenuItem>
                {(localStorage.getItem("userRole") === "pre-processor" ||
                  localStorage.getItem("userRole") === "processor") && (
                  <MenuItem onClick={handlePreviewFIles}>
                    {action.PREVIEW_FILES}
                  </MenuItem>
                )}

                {localStorage.getItem("userRole") === "pre-processor" && (
                  <MenuItem onClick={handlePreviewUploadedFilesClick}>
                    {action.UPLOADED_FILES}
                  </MenuItem>
                )}

                <MenuItem onClick={handleLogout}>{action.LOGOUT}</MenuItem>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>
      {loader === true && <ProgressBar></ProgressBar>}
      {localStorage.getItem("userRole") === "pre-processor" ||
      localStorage.getItem("userRole") === "processor" ||
      localStorage.getItem("userRole") === "validator"
        ? openSignPad && (
            <ModalEsign
              openSignPad={openSignPad}
              handleEsignDialogBoxClose={handleEsignDialogBoxClose}
            ></ModalEsign>
          )
        : ""}

      <div>
        <React.Fragment key={"right"}>
          <SwipeableDrawer
            className="header-toggle"
            anchor={"right"}
            open={openSettingDrawer}
            onClose={(e) => toggleDrawer(false)}
            onOpen={(e) => toggleDrawer(true)}
          >
            <SettingDrawer onClose={() => toggleDrawer(false)} />
          </SwipeableDrawer>
        </React.Fragment>
      </div>
      {openUploadedFilePreviewDialog && (
        <UploadedFilesList
          openUploadedFilePreviewDialog={openUploadedFilePreviewDialog}
          setOpenUploadedFilePreviewDialog={setOpenUploadedFilePreviewDialog}
        />
      )}

      <Snackbar
        open={openAlert}
        autoHideDuration={5000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert onClose={handleAlertClose} severity={severity} icon={icon}>
          {message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
